import React from 'react'

export default function ModalContent ({
  children,
  style = {}
}) {
  return (
    <main style={style}>
      { children }
    </main>
  )
}
